import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const EntityWrapper = styled.div`
  margin-top: 10px;
`;

export const SubHeader = styled.div`
  padding: 1rem 1rem;

  ${media.md`
    padding: 1rem 0;
  `}
`;
